Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("../../../styles");
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var row = {
    flexDirection: 'row',
    width: 'auto',
    flexWrap: 'wrap',
    marginHorizontal: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.xxs, ")") : -1 * spacing.xxs
  };
  var button = {
    width: 'auto',
    height: 'auto',
    margin: spacing.xxs
  };
  var icon = {
    height: (0, _styles.getREM)(2.7),
    width: (0, _styles.getREM)(2.7),
    padding: spacing.s,
    borderRadius: 999
  };
  var styles = _reactNative.StyleSheet.create({
    row: row,
    button: button,
    icon: icon
  });
  return {
    styles: styles
  };
};